import React, { useState, useEffect } from 'react'
import axios from 'axios'
import DataTable from 'react-data-table-component'
import {
  Container,
  Row,
  Col,
  Badge,
  Spinner,
  Alert,
  Form,
} from 'react-bootstrap'
import { FaSortUp, FaSortDown } from 'react-icons/fa'
import {
  MdPending,
  MdCheckCircle,
  MdEventAvailable,
  MdCancel,
} from 'react-icons/md'
import TmsHeader from '../TmsComponents/TmsHeader'
import TmsSidebar from '../TmsComponents/TmsSidebar'
import { useNavigate } from 'react-router-dom'

const Training = () => {
  const [events, setEvents] = useState([])
  const [filteredEvents, setFilteredEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [search, setSearch] = useState('')
  const [sortDirection, setSortDirection] = useState('asc')
  const URL = 'https://kaasbackend.vetrinahealthcare.com/'

  const navigate = useNavigate()

  useEffect(() => {
    const fetchEvents = async () => {
      const token = localStorage.getItem('jwttoken')
      setLoading(true)
      try {
        const { data } = await axios.get(`${URL}tms/training/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        setEvents(data.trainings)
        setFilteredEvents(data.trainings)
        setError(null)
      } catch (error) {
        console.error('Error fetching data:', error)
        setError('Failed to load events. Please try again later.')
      } finally {
        setLoading(false)
      }
    }
    fetchEvents()
  }, [])

  const getStatusColor = (status) => {
    switch (status) {
      case 'Approved':
        return 'success'
      case 'Pending':
        return 'warning'
      case 'Upcoming':
        return 'info'
      case 'Declined':
        return 'danger'
      default:
        return 'primary'
    }
  }

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Approved':
        return (
          <MdCheckCircle
            style={{ marginRight: '3px', verticalAlign: 'middle' }}
          />
        )
      case 'Pending':
        return (
          <MdPending style={{ marginRight: '3px', verticalAlign: 'middle',fontSize: '0.3em' }} />
        )
      case 'Upcoming':
        return (
          <MdEventAvailable
            style={{ marginRight: '3px', verticalAlign: 'middle' }}
          />
        )
      case 'Declined':
        return (
          <MdCancel style={{ marginRight: '3px', verticalAlign: 'middle' }} />
        )
      default:
        return (
          <MdPending style={{ marginRight: '3px', verticalAlign: 'middle' }} />
        )
    }
  }

  const handleSearch = (event) => {
    setSearch(event.target.value)
    const filtered = events.filter((e) =>
      e.title.toLowerCase().includes(event.target.value.toLowerCase())
    )
    setFilteredEvents(filtered)
  }

  const sortIcon = sortDirection === 'asc' ? <FaSortUp /> : <FaSortDown />

  const columns = [
    {
      name: 'ID',
      selector: (row) => row.training_id,
      sortable: true,
      width: '8%',
    },
    {
      name: 'Name',
      selector: (row) => row.title,
      sortable: true,
      width: '13%',
    },
    {
      name: 'Client',
      selector: (row) => row.client,
      sortable: true,
      width: '13%',
    },
    {
      name: 'Event',
      selector: (row) => `${row.start_date}`,
      sortable: true,
      width: '16%',
    },
    {
      name: 'Batch Size',
      selector: (row) => (
        <Badge
          pill
          bg='danger'
          style={{
            padding: '0.25em',
            fontSize: '0.75em',
            width: '24px',
            height: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {row.max_participants}
        </Badge>
      ),
      sortable: true,
      width: '10%',
    },
    { name: 'BY', selector: (row) => row.by, sortable: true, width: '10%' },
    {
      name: 'Created On',
      selector: (row) => row.created_on,
      sortable: true,
      width: '10%',
    },
    {
      name: 'Status',
      selector: (row) => (
        <Badge
          pill
          bg={getStatusColor(row.status)}
          style={{
            fontSize: '0.8em',
          }}
        >
          {getStatusIcon(row.status)} {row.status}
        </Badge>
      ),
      width: '10%',
    },
    {
      name: 'Action',
      cell: (row) => (
        <span
          onClick={() => handleActionClick('View Event', row)}
          style={{
            color: '#6a1b9a',
            cursor: 'pointer',
            fontWeight: '500',
            fontSize: '0.85em',
          }}
        >
          View Event
        </span>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '8%',
    },
  ]

  const customStyles = {
    tableWrapper: {
      style: {
        borderRadius: '10px',
        overflowX: 'hidden',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        fontSize: '0.85em',
        fontWeight: '500',
        color: '#495057',
      },
    },
    rows: {
      style: {
        fontSize: '0.8em',
        color: '#343a40',
        borderBottom: '1px solid #dee2e6',

        '&:hover': {
          backgroundColor: '#f1f3f5',
        },
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
        paddingTop: '0.5em',
      },
    },
  }

  const handleActionClick = (action, row) => {
    navigate(`/viewevent/${row.training_id}`)
  }

  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <TmsSidebar />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <TmsHeader />
        <Container fluid className='py-4'>
          <Row className='justify-content-center'>
            <Col
              lg={12}
              className='shadow p-4 rounded'
              style={{ backgroundColor: '#ffffff', borderRadius: '10px' }}
            >
              <h4 className='text-center mb-4'>All Training List</h4>
              {error && (
                <Alert variant='danger' className='text-center'>
                  {error}
                </Alert>
              )}
              <Row className='mb-3'>
                <Col md={6}>
                  <Form.Control
                    className='rounded'
                    type='text'
                    placeholder='Search by title'
                    value={search}
                    onChange={handleSearch}
                    style={{ fontSize: '0.85em' }}
                  />
                </Col>
              </Row>
              {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' variant='primary' />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredEvents}
                  striped
                  dense
                  pagination
                  highlightOnHover
                  customStyles={customStyles}
                  sortIcon={sortIcon}
                  onSort={(_, sortDirection) => setSortDirection(sortDirection)}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  )
}

export default Training
